var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToolbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 118.7V71H138.4V118.7C138.4 120.46 137.708 122.149 136.473 123.403C135.238 124.656 133.56 125.374 131.8 125.4H23.7C21.9231 125.4 20.2189 124.694 18.9624 123.438C17.7059 122.181 17 120.477 17 118.7Z",
    fill: "#E9AF34",
    stroke: "#E9AF34",
    strokeWidth: 0.499995,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M141.8 51V75.4001H13.7V51C13.6867 50.1249 13.8476 49.2559 14.1734 48.4436C14.4991 47.6313 14.9832 46.8919 15.5974 46.2684C16.2115 45.6449 16.9436 45.1498 17.751 44.8118C18.5583 44.4739 19.4248 44.2999 20.3 44.3H135.1C135.98 44.3 136.851 44.4734 137.664 44.8101C138.477 45.1468 139.215 45.6403 139.838 46.2624C140.46 46.8846 140.953 47.6232 141.29 48.4361C141.627 49.249 141.8 50.1202 141.8 51Z",
    fill: "#E9AF34",
    stroke: "#E9AF34",
    strokeWidth: 0.499995,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8999 76.6001H144.5",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2 69H40.6C39.9925 69 39.5 69.4925 39.5 70.1V80.63C39.5 81.2375 39.9925 81.73 40.6 81.73H43.2C43.8075 81.73 44.3 81.2375 44.3 80.63V70.1C44.3 69.4925 43.8075 69 43.2 69Z",
    fill: "#1F323D",
    stroke: "#1F323D",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M114.8 69H112.2C111.592 69 111.1 69.4925 111.1 70.1V80.63C111.1 81.2375 111.592 81.73 112.2 81.73H114.8C115.407 81.73 115.9 81.2375 115.9 80.63V70.1C115.9 69.4925 115.407 69 114.8 69Z",
    fill: "#1F323D",
    stroke: "#1F323D",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2998 45.3V32.9C56.2998 31.8657 56.7107 30.8737 57.4421 30.1423C58.1735 29.4109 59.1655 29 60.1998 29H95.2998C96.3262 29.0254 97.3035 29.4444 98.0295 30.1704C98.7554 30.8963 99.1744 31.8736 99.1998 32.9V45.3",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7999 44.9001V36.2001C92.8169 36.0911 92.808 35.9796 92.7739 35.8748C92.7397 35.7699 92.6813 35.6746 92.6033 35.5966C92.5253 35.5186 92.43 35.4602 92.3251 35.426C92.2203 35.3919 92.1088 35.383 91.9999 35.4001H63.3999C63.1877 35.4001 62.9842 35.4843 62.8342 35.6344C62.6841 35.7844 62.5999 35.9879 62.5999 36.2001V44.9001",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolbox);
export default __webpack_public_path__ + "static/media/toolbox.34ffc85afad7f50ea3b27a6cc41195ca.svg";
export { ForwardRef as ReactComponent };